<template>
  <ContainerBasic
    container-type="CONTENT"
    class="px-md md:px-0 print:w-[700px] print:mx-auto"
    :style="pageBreak(blockData.printPageBreak)"
  >
    <HeadlineDynamic
      v-if="blockData.headline"
      :headline="blockData.headline"
      level="h4"
      :has-decoration="true"
      class="mx-auto mb-sm md:mb-md"
    />
    <div
      v-if="blockData.layoutFlow == EListFlow.TopToBottom"
      class="w-full grid-flow-row grid-cols-none grid-rows-none mx-auto md:grid auto-cols-fr md:grid-flow-col md:grid-rows-1 gap-x-md"
      :class="`grid-rows-${blockData.columns}`"
    >
      <BulletList
        v-for="(listItems, index) in listItemsList_topToBottom"
        :key="index"
        class="col-span-1 row-span-1 m-0"
        :list-type="blockData.listStyle"
        :list-items="listItems"
        :start-index="index * listItemsList_topToBottom[0].length + 1"
      />
    </div>
    <div
      v-else-if="blockData.layoutFlow == EListFlow.LeftToRight"
      class="grid w-full grid-cols-1 mx-auto print:grid-cols-4 auto-rows-min gap-x-md print:font-sm"
      :class="`md:grid-cols-${blockData.columns}`"
    >
      <BulletList
        v-for="(listItems, index) in blockData.listItems"
        :key="index"
        class="col-span-1 row-span-1 m-0"
        :list-type="blockData.listStyle"
        :list-items="[listItems]"
        :start-index="index + 1"
      />
    </div>
    <span
      class="hidden grid-rows-1 grid-rows-2 grid-rows-3 grid-rows-4 md:grid-cols-1 md:grid-cols-2 md:grid-cols-3 md:grid-cols-4"
    ></span>
  </ContainerBasic>
</template>

<script lang="ts" setup>
import { type IListItem, EListFlow } from '@/@types/bullet-list';
import ContainerBasic from '@/components/components/container-basic.vue';
import BulletList from '@/components/components/core/bullet-list/bullet-list.vue';
import HeadlineDynamic from '@/components/components/core/headline-dynamic/vdv/headline-dynamic.vue';
import type { ContentEnumerationData } from '../blockType';

const props = defineProps({
  blockData: {
    type: Object as PropType<ContentEnumerationData>,
    required: true,
    default: {} as ContentEnumerationData,
  },
});

const listItemsList_topToBottom = computed<IListItem[][]>(() => {
  const listItems = props.blockData.listItems;

  const columns = props.blockData.columns;
  const steps = Math.ceil(listItems.length / columns);
  const listArray = [];

  for (let i = 0; i < columns; i++) {
    const sliceStart = i * steps;
    const sliceEnd = steps * (i + 1);
    listArray.push(listItems.slice(sliceStart, sliceEnd));
  }
  return listArray;
});

function pageBreak(pageBreak: any) {
  if (pageBreak === 'break-before') {
    return 'page-break-before: always';
  }
  if (pageBreak === 'break-after') {
    return 'page-break-after: always';
  }

  return '';
}
</script>
